import { httpClient } from '../httpClient';

export const dashboardApi = {
  getFull: (timeRange) => httpClient.get('/dashboard/full', { params: timeRange ? { time_range: timeRange } : undefined }),
  getRoleConfig: () => httpClient.get('/dashboard/role-config'),
  resolveActionItem: (type, id, action) =>
    httpClient.post(`/dashboard/action-items/${type}/${id}/resolve`, { action }),
  getPreferences: () => httpClient.get('/dashboard/preferences'),
  savePreferences: (data) => httpClient.put('/dashboard/preferences', data),
  listRegulatoryUpdates: () => httpClient.get('/dashboard/regulatory-updates'),
  createRegulatoryUpdate: (data) => httpClient.post('/dashboard/regulatory-updates', data),
  updateRegulatoryUpdate: (id, data) => httpClient.put(`/dashboard/regulatory-updates/${id}`, data),
  deleteRegulatoryUpdate: (id) => httpClient.delete(`/dashboard/regulatory-updates/${id}`),
  getWidget: (widgetId, timeRange) =>
    httpClient.get(`/dashboard/widget/${widgetId}`, { params: timeRange ? { time_range: timeRange } : undefined }),
};
